import React from 'react';
export function ProductSection() {
  return <section className="py-10 px-5 bg-negro" data-id="element-119">
      <div className="max-w-[1000px] mx-auto" data-id="element-120">
        <div className="text-center mb-8" data-id="element-121">
          <p className="text-[12px] tracking-[3px] uppercase text-oro-rosa mb-2 font-bold" data-id="element-122">
            💎 Tu sistema completo incluye
          </p>
          <h2 className="font-playfair text-[clamp(24px,3.5vw,38px)] text-blanco mb-2" data-id="element-123">
            2 Tomos Maestros + 4 Bonos Exclusivos
          </h2>
          <p className="text-[16px] text-oro-rosa-claro" data-id="element-124">
            Todo lo que necesitás para dominar la técnica, el branding y las
            ventas
          </p>
        </div>

        <div className="bg-gradient-tomo rounded-2xl p-6 mb-5 border-l-4 border-oro-rosa relative overflow-hidden transition-all duration-300 hover:translate-x-1 hover:shadow-[-10px_0_30px_rgba(201,149,108,0.2)]" data-id="element-125">
          <div className="text-[60px] font-black absolute right-5 top-3 opacity-5 font-playfair text-oro-rosa" data-id="element-126">
            01
          </div>
          <div className="inline-block bg-gradient-gold-rose text-negro py-1 px-3 rounded-full text-[11px] font-bold tracking-[1px] mb-2" data-id="element-127">
            📘 TOMO 1
          </div>
          <h3 className="font-playfair text-[clamp(20px,2.5vw,28px)] text-blanco mb-1" data-id="element-128">
            La Alquimia Estética
          </h3>
          <p className="text-[14px] text-oro-rosa-claro mb-4 italic" data-id="element-129">
            El Arte del Chocolate Profesional — De la cocina a la joyería
          </p>
          <ul className="list-none grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-130">
            {['Método de Sembrado: brillo espejo sin mármol ni maquinaria', 'Cobertura Real vs. Baño de Repostería: cuándo usar cada uno', 'Las 4 técnicas de pintura y color que dominan Instagram 2026', 'Moldes policarbonato vs. silicona: acabado diamante perfecto', 'Almacenamiento en climas argentinos húmedos y calurosos', 'Paso a paso de tu primera producción profesional'].map((item, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-texto-claro leading-[1.4]" data-id="element-131">
                <span className="text-dorado text-[13px] shrink-0 mt-0.5" data-id="element-132">
                  ✦
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="bg-gradient-tomo rounded-2xl p-6 mb-5 border-l-4 border-teal relative overflow-hidden transition-all duration-300 hover:translate-x-1 hover:shadow-[-10px_0_30px_rgba(78,205,196,0.2)]" data-id="element-133">
          <div className="text-[60px] font-black absolute right-5 top-3 opacity-5 font-playfair text-oro-rosa" data-id="element-134">
            02
          </div>
          <div className="inline-block bg-gradient-teal text-negro py-1 px-3 rounded-full text-[11px] font-bold tracking-[1px] mb-2" data-id="element-135">
            📗 TOMO 2
          </div>
          <h3 className="font-playfair text-[clamp(20px,2.5vw,28px)] text-blanco mb-1" data-id="element-136">
            El Negocio Visual
          </h3>
          <p className="text-[14px] text-teal mb-4 italic" data-id="element-137">
            Branding, Fotografía y Ventas para el Emprendedor Argentino
          </p>
          <ul className="list-none grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-138">
            {['Identidad de marca desde cero sin contratar diseñador', 'Estrategia de precios que funciona con inflación semanal', 'Primeros 10 clientes sin gastar en publicidad paga', 'Instagram y WhatsApp trabajando para vos mientras dormís', 'Logística de envíos: chocolate brillante y entero', 'Plan de 90 días para escalar a negocio rentable'].map((item, i) => <li key={i} className="flex items-start gap-2 text-[14px] text-texto-claro leading-[1.4]" data-id="element-139">
                <span className="text-teal text-[13px] shrink-0 mt-0.5" data-id="element-140">✦</span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}